import React from "react";
import { Td } from "@chakra-ui/react";
import { useHistory } from "react-router-dom";

import { ChakraText } from "components/ChakraText";

import { IAppointmentDetails } from "../../../../application/types/IAppointmentDetails";
import { useGetFriendlyUrl } from "../../../../../../utils/hooks/useGetFriendlyUrl";
import { AppointmentRowContainer } from "../../components/AppointmentRowContainer";
import { AppointmentStartDate } from "../../components/AppointmentStartDate";
import { AppointmentStatusTag } from "../../../AppointmentStatusTag";
import { AppointmentActionButtons } from "./AppointmentActionButtons";

interface IProps {
  appointment: IAppointmentDetails;
}

const AppointmentRow = ({ appointment }: IProps) => {
  const { push } = useHistory();
  const { friendlyUrl } = useGetFriendlyUrl();

  return (
    <AppointmentRowContainer
      onClick={() =>
        push(
          `/e-rezerwacja/${friendlyUrl}/uzytkownik/aktualne-wizyty/${appointment.appointmentId}`
        )
      }
      id={`appointment-${appointment.appointmentId}-row`}
    >
      <Td maxW={"150px"} wordWrap="break-word">
        <AppointmentStartDate appointmentStartDate={appointment.startDate} />
      </Td>
      <Td maxW={"150px"} wordWrap="break-word">
        <ChakraText isTruncated>{appointment.orgUnitFullName}</ChakraText>
      </Td>
      <Td maxW={"150px"} wordWrap="break-word">
        <ChakraText isTruncated>{appointment.queueName}</ChakraText>
      </Td>
      <Td maxW={"150px"} wordWrap="break-word">
        <ChakraText isTruncated>{appointment.groupName}</ChakraText>
      </Td>
      <Td maxW={"150px"} wordWrap="break-word">
        <AppointmentStatusTag status={appointment.status} />
      </Td>
      <Td>
        <AppointmentActionButtons appointment={appointment} />
      </Td>
    </AppointmentRowContainer>
  );
};

export { AppointmentRow };
